import React, { useEffect, useMemo, useState } from "react";
import style from "./style.module.scss";
import Header from "../../../components/Header";
import LoadingWrapper from "../../../components/LoadingWrapper";
import useRequest from "../../../utils/useRequest";
import {
    getExamInfo,
    getExamPaperList,
    getThesisPaper
} from "../../../service/exam";
import ThesisForm from "./components/ThesisForm";
import { errorMessage, isTrue } from "../../../service/service";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";

interface PageLunWenAddProps {
    match: {
        params: {
            examId: string;
            readonly: string;
        };
    };
}

export default function PageLunWenAdd({
    match: { params }
}: PageLunWenAddProps) {
    const [paperId, setPaperId] = useState(""); //试卷id

    const [examPaperData, {}, updateData] = useRequest(
        () => getExamPaperList(params.examId),
        {},
        [params.examId]
    );
    const [getData, { loading, data: topic }] = useRequestFn(getThesisPaper);
    const [examData, { loading: loadingExamData }] = useRequest(() =>
        getExamInfo(params.examId)
    );

    useEffect(() => {
        if (!examPaperData) return;
        if (examPaperData?.length !== 0) {
            setPaperId(examPaperData[0].paperId);
        }
    }, [examPaperData]);

    useEffect(() => {
        if (!paperId) return;
        loadPaperData();
    }, [paperId]);

    async function loadPaperData() {
        try {
            await getData(paperId);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    // 当前试卷是否有学员在做(有的话不允许修改试卷和试题)
    const lockEdit = useMemo(() => {
        if (params.readonly === "1") return true;
        return examData ? !isTrue(examData.editable) : false;
    }, [examData]);

    return (
        <div>
            <Header />

            <LoadingWrapper
                isEmpty={!examData}
                loading={loading || loadingExamData}>
                {() => (
                    <div className={style.root}>
                        <h1 className={style.title}>{examData!.name}</h1>
                        <ThesisForm
                            topic={topic}
                            paperId={paperId}
                            lockEdit={lockEdit}
                            updateData={updateData}
                        />
                    </div>
                )}
            </LoadingWrapper>
        </div>
    );
}
